//We should be able to remove date-fns-tz when this is done. https://github.com/date-fns/date-fns/issues/873
import { format } from 'date-fns-tz';
import { fromUnixTime } from 'date-fns';

export const safeFromUnixTime = (saleStartTs?: number) => {
    let date = new Date();
    if (!saleStartTs) {
        return date;
    }
    try {
        date = fromUnixTime(saleStartTs);
    } catch (error) {
        console.log(error);
    }
    return date;
};

export const catalogLongCardDate = (saleStartTs: number) =>
    format(safeFromUnixTime(saleStartTs), 'eee, MMM dd, yyyy h:mm a zz');

export const catalogCardDate = (saleStartTs: number) => format(safeFromUnixTime(saleStartTs), 'MMM dd, yyyy h:mm a zz');

export const formatLongDate = (saleStartTs: number) => format(safeFromUnixTime(saleStartTs), 'MMMM do, yyyy zz');

export const formatShortDate = (saleStartTs: number) => format(safeFromUnixTime(saleStartTs), 'MMMM do, yyyy');

export const formatShorterDate = (saleStartTs: number) => format(safeFromUnixTime(saleStartTs), 'MMM dd, yyyy');

export const formatShortDateDay = (saleStartTs: number) => format(safeFromUnixTime(saleStartTs), 'eee, MMM dd, yyyy');

export const formatShortTimeOnly = (saleStartTs: number) => format(safeFromUnixTime(saleStartTs), 'h:mm a zz');
